import { sendRequest } from './rootApi';
import Api from "../constants/Api";

export const loadVideoData = async (params) => {
    return sendRequest("post", Api.loadVideoData, params);
}

export const getConverstionDataApi = async (params) => {
  return sendRequest("post", Api.getChatConversation, params);
}